import { Component, OnInit, Input, OnChanges, NgModuleFactoryLoader } from '@angular/core';
import { Item, IItem } from '../../models/IItem';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser'
import { Utils } from '../../Utils';
import { S1DataService } from '../../services/s1data.service';
import { RouteDataService } from '../../services/routedata.services';
import { FezaDataService } from '../../services/fezadata.service';
import { QuotaViewerComponent } from '../quota-viewer/quota-viewer.component';
import { IBid, Bid } from '../../models/IBid';
import { IBidResponse, BidResponse, ISampleBlendType } from '../../models/IBidResponse'
import { ISample } from '../../models/ISample';
import { SafeUrl } from '@angular/platform-browser/src/security/dom_sanitization_service';
import { ISupplier, ISupplierMap } from '../../models/ISupplier';
import { ITextItem } from '../../models/ITextItem';
import { QuotaAllocationModeByName } from '../../enums/quota-allocation-mode.enum';
import { ISampleBlend } from '../../models/ISampleBlend';
import { ITotalKey } from '../../models/ITotalKey';
import { ICpiRange } from "../../models/ICpiRange";
import { IQuestion } from '../../models/IQuestion';
import { IS1Question } from '../../models/IS1Question';
import { Observable } from 'rxjs';
import { ICurrency } from '../../models/ICurrency';
import { ITemplateCriteria } from '../../models/ITemplateCriteria';
import { ICost, Cost, ICostByFieldDuration } from '../../models/ICost';
import { NgbTab, NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { debug } from 'util';

interface ResponseEditOk { //local interface used only in component's html
  name: string;
  supported: boolean;
  id: number;
}

@Component({
  selector: 'app-response-edit',
  templateUrl: './response-edit.component.html',
  styleUrls: ['./response-edit.component.css']
})

export class ResponseEditComponent implements OnInit
{
  bidId: string;
  bidResponse: IBidResponse;
  fezaId: string;
  supplierId: number;
  feasibility: ISample;         //the sample row for the supplier response.
  requestedFeasibility: ISample;//the sample row requested, might have details the supplier didn't echo back.
  saving: boolean;
  newCPIs: Map<string,Array<ICpiRange>>;
  event: string;
  sid: string;
  questions: Array<ResponseEditOk>;
  bidCurrencies$: Observable<ICurrency[]>;

  constructor(private route: ActivatedRoute,
    private s1DataService: S1DataService,
    private routeDataService: RouteDataService,
    private fezaDataService: FezaDataService,
    private router: Router,
    private sanitizer: DomSanitizer) {

    this.newCPIs = new Map<string, Array<ICpiRange>>();
    this.route.queryParams.subscribe(params => {
      this.bidId = params['bidId'];
      this.fezaId = params['fezaId'];
      this.supplierId = parseInt(params['supplierId']);
      this.event = params['event'];
      this.sid = params['sid'];
    });
  }

  ngOnInit() {
    this.newCPIs = new Map<string, Array<ICpiRange>>();
    this.bidCurrencies$ = this.s1DataService.getCurrencies();
    this.routeDataService.routedBidResponseValue.subscribe(routedBid => {
      if (routedBid != null) {
        //get the db version of the request to make sure the question names are filled in.  :-P
        this.fezaDataService.GetResponse(routedBid.request.bidId,null).subscribe(serverVersion => {
          routedBid.request = serverVersion.request;
          this.setupBid(routedBid);
        });
      }
      else
        this.showResponse();
    });
  }

  getCostFieldDurations(sample: ISample): string[] { return Utils.getCostDurations(sample); }

  setupQuestionCheckBoxes(supplierSample: ISample, requestedSample: ISample) {
    //setup the check boxes with the suppplier's sample results, but use the requested feasiblity to setup the name by id mapping (since we only have it there.)
    let supplierSupported = new Map<string, [boolean, number]>();
    let questionIdToName = new Map<number, string>();
    Utils.visitQuestionInSample(requestedSample, q => { questionIdToName.set(q.id, q.name) });
    Utils.visitQuestionInSample(supplierSample, q => {
      let supported: boolean = (q.responseCode || "Ok") === "Ok";
      supplierSupported.set(questionIdToName.get(q.id), [supported, q.id]);
    });
    var questions = Array<ResponseEditOk>(); 
    supplierSupported.forEach(([supported, id], name) => { questions.push({ name: name, supported: supported, id: id } as ResponseEditOk); });
    this.questions = questions;
  }

  setupBid(bid: IBidResponse) {
    this.feasibility = null;
    this.requestedFeasibility = null;
    this.bidResponse = bid;
    
    this.newCPIs = new Map<string, Array<ICpiRange>>();

    for (let key in bid.feasibilities) {
      for (let sample of bid.feasibilities[key]) {
        if (sample.supplierId === this.supplierId && sample.feasibilityId.toLowerCase() == this.fezaId.toLowerCase()) {
          sample.costs = sample.costs || {} as ICostByFieldDuration;
          this.requestedFeasibility = this.bidResponse.request.feasibilities.find(x => x.feasibilityId.toLowerCase() == sample.feasibilityId.toLowerCase());
          for (let fd of Utils.getCostDurations(sample))
            this.newCPIs[fd] = [{ cpi: null, completesBetween: [null, null] } as ICpiRange];//setup a new "empty" row for a new CPI range
          this.feasibility = sample;
          if (sample.internalSupplier || sample.virtualPanel){
            //virt/int panel with no cost ranges? Let's load some up from the templates!
            this.loadRateCards(this.requestedFeasibility, sample, bid.request.bidCurrency);
          }
          this.setupQuestionCheckBoxes(sample, this.requestedFeasibility);
          sample.supplierTotalCompletes = sample.supplierTotalCompletes || {};
          for (let key of Utils.HoursToFieldDurLables(this.requestedFeasibility.hoursInField, this.requestedFeasibility.flexibleFieldDuration)) {
            sample.supplierTotalCompletes[key] = (sample.supplierTotalCompletes[key] || 0);
          }
        }
      }
    }
  }

  loadRateCards(requestSample: ISample, sample: ISample, bidCurrency: string) {
    this.fezaDataService.getRateCardsAllTargets({
      supplierId: this.supplierId,
      loi: requestSample.lengthOfInterview,
      incidence: Math.round(requestSample.incidenceRatePercent),
      researchTypeName: requestSample.researchType,
      countryCode: requestSample.countryCode,
      languages: requestSample.countryCultures.join(","),
      sampleCategoryId: requestSample.sampleCategoryId,
      sampleSubcategoryId: requestSample.sampleSubCategoryId,
      completes: Number(requestSample.numberOfCompletes),
      fieldworkDuration: requestSample.hoursInField
    } as ITemplateCriteria, bidCurrency).subscribe(ranges => {
      for (let fd in this.feasibility.supplierTotalCompletes){
        let cost: ICost = new Cost();
        cost.cpi = 0;
        cost.cpiRanges = Object.assign([], ranges);
        cost.currency = bidCurrency;
        sample.costs[fd] = cost;
        this.feasibility = sample;
      }
    });
  }

  onChangeCostCurrency(displayCurrency){
    //i don't want to make the user change each currency drop down... yuck.
    var code = displayCurrency.code;
    for (var fd of Utils.getCostDurations(this.feasibility)) {
      this.feasibility.costs[fd].currency = code;
    }
  }

  quotaAllocationModeLabel(qaName:string) {
    return QuotaAllocationModeByName(qaName).label;
  }

  onTotalsUpdatedForQuota(newTotals: ITotalKey) {
    //we got a total updated for a cell on a duration.
    //find all the totals by table name
    //then set the overall value to the smallest sum per table
    //that is how many the panel can support for that table for that duration key
    this.feasibility.supplierTotalCompletes[newTotals.totalKey] = 0
    let totalByTable: { [tableName: string]: number } = {};
    for (let qt of this.feasibility.quotaTables)
      for (let quota of qt.quotas) {
        totalByTable[qt.tableName] = (totalByTable[qt.tableName] || 0) + quota.completes[newTotals.totalKey];
      }
    for (let table in totalByTable) {
      if (this.feasibility.supplierTotalCompletes[newTotals.totalKey] === 0)
        this.feasibility.supplierTotalCompletes[newTotals.totalKey] = totalByTable[table];
      else
        this.feasibility.supplierTotalCompletes[newTotals.totalKey] = Math.min(this.feasibility.supplierTotalCompletes[newTotals.totalKey], totalByTable[table])
    }

  }

  onTotalUpdatedForFeasibility(newTotals: ITotalKey) {
    for (let qt of this.feasibility.quotaTables)
      for (let quota of qt.quotas) {
        quota.completes[newTotals.totalKey] = (1.0 * quota.percentage / 100.00) * newTotals.value;
      }
  }

  onMaybeAddMoreCpis(fd:string) {
    var hasMissingRow = false;
    for (let item of (this.newCPIs[fd] || [])) {
      if (!item.cpi)
        hasMissingRow = true;
    }
    if (!hasMissingRow) {
      if (this.newCPIs[fd] === null)
        this.newCPIs[fd] = [];
      this.newCPIs[fd].push({ cpi: null, completesBetween:[null,null] } as ICpiRange);
    }
  }

  saveResponseChanges() {
    this.saving = true;
	  for (let fd in this.newCPIs) {
		  for (let item of this.newCPIs[fd]) {
			  if (item.cpi || item.completesBetween) {
				  if (!this.feasibility.costs[fd].cpiRanges) this.feasibility.costs[fd].cpiRanges = [];
				  this.feasibility.costs[fd].cpiRanges.push(item);
			  }
		  }
	  }
    Utils.visitQuestionInSample(this.feasibility, q => {
      for (let question of this.questions) {
        if (q.id === question.id)
          q.responseCode = question.supported ? "Ok" : "UnsupportedVariable";
      }
    });
    for (let fd in this.feasibility.costs) {
      this.feasibility.costs[fd].cpiRanges = this.feasibility.costs[fd].cpiRanges.filter(c => !((c.completesBetween === null || (c.completesBetween[0] === null && c.completesBetween[1] === null)) && c.cpi === null));
    }
    this.fezaDataService.SaveSupplierFeasibilityResponse(this.feasibility).subscribe(saved => { this.showResponse(); },

      err => {
        console.log(`save error:${err}`);
        this.saving = false;
      });
  }

  onCancel() {
    this.reloadResponse();
  }

  private showResponse() {
    let url: string = `/response?bidId=${this.bidId}`;
    if (this.event) url += `&event=${this.event}`;
    if (this.sid) url += `&sid=${this.sid}`;
    this.router.navigateByUrl(url);
  }

  private reloadResponse() {
    let url: string = `/response?bidId=${this.bidId}`;
    if (this.event) url += `&event=${this.event}`;
    if (this.sid) url += `&sid=${this.sid}`;
    url += '&reload=1';
    this.router.navigateByUrl(url);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/response-edit/response-edit.component.ts